module.exports = __webpack_public_path__ + "static/media/personal-protective-equipment-manage.a947f212.svg";